import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export function AbTestingFeatureGate(props: Props) {
    return (
        <FeatureGateModalWrapper
            feature='abTesting'
            isOpen={props.isOpen}
            onClose={() => props.setIsOpen(false)}
            bullets={[
                'Test two different subjects, preview text, and content against each other',
                "Nutshell will send both versions to your audience, and then determine a winner. The 'best' version is then sent to the remainder of the audience",
                'Compare results across versions to determine what’s working best',
            ]}
            description='See what resonates best with your audience with email A/B testing.'
            title='Upgrade to unlock A/B testing'
        />
    );
}
